import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { PtLuxonDate } from '../../../../../models/projects/date.models';
import {
  DailyLegLoadStandaloneEditor
} from '../../../../../models/daily-leg-loads/daily-leg-load.models';
import {
  DailyLegLoadStandaloneService
} from '../../../../../services/daily-leg-loads/daily-leg-load-standalone.service';
import { standaloneReadingColumns } from './daily-leg-load-standalone-reading.config';

@Component({
  selector: 'daily-leg-loads-standalone-reading-grid',
  templateUrl: 'daily-leg-load-standalone-reading-grid.html'
})
export class DailyLegLoadStandaloneReadingGridComponent {
  @Input() dailyLogDate: PtLuxonDate;
  @Input() loading: boolean;
  @Output() public addStandaloneReadingClicked: EventEmitter<void> = new EventEmitter();
  @Output() public deleteStandaloneReadingClicked: EventEmitter<DailyLegLoadStandaloneEditor> = new EventEmitter();
  @ViewChild('additionalReadingsGrid') additionalReadingsGrid?: GridComponent;

  gridData: GridDataResult;
  columns = standaloneReadingColumns;
  standaloneReadings: DailyLegLoadStandaloneEditor[];

  state: State = {
    take: 5,
    skip: 0,
    filter: {
      logic: 'and',
      filters: []
    },
    sort: [
      {
        field: 'effectiveFromDate',
        dir: 'asc'
      },
    ],
  };

  constructor(private dailyLegLoadStandaloneService: DailyLegLoadStandaloneService) {

  }

  ngOnInit() {
    this.loadGrid();
  }

  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.loadItems();
  }

  emitDeleteStandaloneReading(row: DailyLegLoadStandaloneEditor) {
    this.deleteStandaloneReadingClicked.emit(row);
  }

  emitAddStandaloneReading() {
    this.addStandaloneReadingClicked.emit();
  }

  private async loadGrid() {
    this.dailyLegLoadStandaloneService.getGridData(this.dailyLogDate.dateTime).then(data => {
      this.standaloneReadings = data;
      this.loadItems();
    });
  }

  private loadItems(): void {
    this.gridData = process(this.standaloneReadings, this.state);
  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-manage-readings/components/daily-leg-load-standalone-reading-grid/daily-leg-load-standalone-reading-grid.ts